import apiConfig from "@/config/apiConfig";

const rootPath = apiConfig.companyApi;

export const sys_finance_demand  = {
   pageListWeb: rootPath + "/enterpriseFinanceDemand/pageListWeb",
   detail : rootPath + "/enterpriseFinanceDemand/detail",
   validateYear : rootPath + "/enterpriseFinanceDemand/validateYear/",//  根据年份判断是否做过积分制
   saveOrUpdate:rootPath + "/enterpriseFinanceDemand/saveOrUpdate",
   remove:rootPath + "/enterpriseFinanceDemand/remove/",
   getDate: rootPath + "/enterpriseFinanceDemand/getDate", // 获取填报时间段(get)
   getYear: rootPath+ "/enterpriseFinanceDemand/getYear",
}
